import api from './api';
import { AiOrderSearchResult } from '../types/order/AiOrderSearchResult';

const AI_ORDER_SEARCH_TIMEOUT_IN_MILLISECONDS = 60_000;

export const interpretOrderSearch = (query: string): Promise<AiOrderSearchResult> =>
    api.postWithResponseType<{ query: string }, AiOrderSearchResult>(
        '/ai/order-search',
        { query },
        undefined,
        { timeout: AI_ORDER_SEARCH_TIMEOUT_IN_MILLISECONDS }
    );
